<template>
    <v-app id="app">
        <v-container class="my-15 px-10 text-body-1 monsterrat">
                <v-layout row>
                    <v-flex>

                         <v-row>
                            <v-col>
                              <p class=" text-h4 text-md-h4 font-weight-bold monsterrat"> <span> Level Test - Advanced </span> </p>
                           
                              <p class="font-weight-bold text-body-2 text-lg-h6 text-md-h6 monsterrat"> <span class="font-weight-medium"> Please do the following activities. </span> </p>
                            </v-col>
                      </v-row>

                      <v-layout row wrap class="mt-5" justify-sm-center>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 2. Repetition </span></p> 
                                
                                  <v-card class="px-2 py-lg-4 pb-lg-3 py-md-5 py-10 blue lighten-4 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Please repeat exactly how you heard the sentences. (Choose 2.).</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                
                                                  <v-card class="white px-5 py-6 elevation-0 text-lg-body-1 text-md-body-2">
                                                        <v-layout row wrap >
                                                            <v-flex md6>
                                                                <v-col>
                                                                       1. He is a lawyer in Wall Street.

                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                        2. Swimming helps me stay fit.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                       3. Steve played golf yesterday morning.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                      4. I was with Milly yesterday.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                        5. We elected him president of our class.
                                                                </v-col>
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-col>
                                                                6. His work became famous all over the world.
                                                                </v-col>
                                                            </v-flex>
                                                            
                                                            
                                                        </v-layout>
                                                    
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 3. Sentence Construction </span></p> 
                                
                                  <v-card class="px-2 py-lg-9 pb-lg-16 py-md-10 py-10 blue lighten-4 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Make one sentence for each word given.</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                         <v-layout justify-center>
                                            <v-flex xs6 lg12 md12>
                                                
                                                  
                                                        <v-layout row wrap justify-lg-space-around  justify-md-space-around  class="mt-2">
                                                            <v-flex md5 xs12 class="mt-sm-4 mt-0">
                                                                <v-card class="py-5 px-5 elevation-0">
                                                                   <v-img src="../../../../../assets/images/LevelTest/leveltest/review.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                <v-layout xs6 lg 4 md2 justify-center class="mt-2"><span> review  </span></v-layout>
                                                                </v-card>
                                                            </v-flex>
                                                            <v-flex md5 xs12 class="mt-sm-4 mt-4 elevation-0">
                                                                <v-card class="py-5 px-5 elevation-0">
                                                                   <v-img src="../../../../../assets/images/LevelTest/leveltest/interact.png" aspect-ratio="1" max-height="100" contain></v-img>
                                                                    <v-layout xs6 lg 4 md2 justify-center class="mt-2"><span> interact  </span></v-layout>
                                                                </v-card>
                                                            </v-flex>
                                                            
                                                            
                                                        </v-layout>
                                                    
                                                 
                                            </v-flex>
                                         </v-layout>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                            <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 4. Freetalking </span></p> 
                                
                                  <v-card class="px-2 py-lg-5 py-md-4 py-10 pb-lg-16  blue lighten-4 elevation-0 rounded-xl">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Please answer the questions the best way you can. (Choose 2.)</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="white px-5 py-5 elevation-0 text-lg-body-1 text-md-body-2 ">
                                                    <p >
                                                       1. Where would you want to go right now? Why?

                                                    </p>
                                                    <p >
                                                        2. Why do you want to study English?

                                                    </p>
                                                    <p >
                                                        3. How can you help clean the Earth?

                                                    </p>
                                                    <p >
                                                     4. Why is the weather very unpredictable nowadays?

                                                    </p>
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>

                             <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> Reminders </span></p> 
                                
                                  <v-card class="px-2 py-lg-6 pb-lg-7 py-md-10 py-10  blue lighten-4 elevation-0 rounded-xl">

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="px-5 py-10 elevation-0 text-center blue lighten-4">

                                                   <div> Reintroduce yourself after completing the activities.</div>
                                                  <div class="mt-1">  Thank the student. </div>
                                                  <div class="mt-1">  Tell the student that they can check their results within today.  </div>
                                                  <div class="mt-1">  If they have any questions, they can visit our website.   </div>

                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>


                      </v-layout>

                    </v-flex>
                </v-layout>
        </v-container>
    </v-app>
</template>
<script>
export default {
    name : 'Advanced'
}
</script>
<style scoped>
.monsterrat {
    font-family: 'Montserrat', serif !important;
}
</style>